import React from 'react';
import '../styles/Header.css';

const Header = () => {
  return (
    <header className="header">
      <h1 className="logo">Loafy</h1>
    </header>
  );
};

export default Header;
